import { Controller } from "@hotwired/stimulus"

// Simple controller to navigate to a hash when a select changes
export default class extends Controller {
    navigate(event) {
        const hash = event.target.value
        if (hash) {
            window.location.hash = hash
        }
    }
}

